import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3469ea63"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "reviewComments",
    class: "comments"
};
const _hoisted_2 = { class: "comment__name-rating" };
const _hoisted_3 = { class: "comment__name-rating-name" };
const _hoisted_4 = { class: "comment__name-rating-date" };
const _hoisted_5 = { class: "comment__name-rating-stars" };
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = { class: "comment__metadata" };
const _hoisted_12 = { class: "comment__metadata-type" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "TYPE:", -1 /* HOISTED */));
const _hoisted_14 = { class: "comment__metadata-model" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "MODEL:", -1 /* HOISTED */));
const _hoisted_16 = { class: "comment__metadata-year" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "MODEL YEAR:", -1 /* HOISTED */));
const _hoisted_18 = { class: "comment__text" };
const _hoisted_19 = {
    key: 0,
    class: "comment__dealer-response"
};
const _hoisted_20 = { class: "comment__dealer-response__date response-detail" };
const _hoisted_21 = { class: "comment__dealer-response__name response-detail" };
const _hoisted_22 = { class: "comment__dealer-response__text response-detail" };
const _hoisted_23 = { class: "page-buttons" };
const _hoisted_24 = ["disabled"];
const _hoisted_25 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: comment.commentId,
                        class: "comment"
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(comment.reviewer.displayName), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(comment.date), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_5, [
                                _createElementVNode("img", {
                                    src: comment.starOneImagePath
                                }, null, 8 /* PROPS */, _hoisted_6),
                                _createElementVNode("img", {
                                    src: comment.starTwoImagePath
                                }, null, 8 /* PROPS */, _hoisted_7),
                                _createElementVNode("img", {
                                    src: comment.starThreeImagePath
                                }, null, 8 /* PROPS */, _hoisted_8),
                                _createElementVNode("img", {
                                    src: comment.starFourImagePath
                                }, null, 8 /* PROPS */, _hoisted_9),
                                _createElementVNode("img", {
                                    src: comment.starFiveImagePath
                                }, null, 8 /* PROPS */, _hoisted_10)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                _createTextVNode(" " + _toDisplayString(comment.category), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                                _hoisted_15,
                                _createTextVNode(" " + _toDisplayString(comment.model), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                _hoisted_17,
                                _createTextVNode(" " + _toDisplayString(comment.modelYear), 1 /* TEXT */)
                            ])
                        ]),
                        _createElementVNode("p", _hoisted_18, _toDisplayString(comment.text), 1 /* TEXT */),
                        (comment.dealerResponse.text.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("span", _hoisted_20, _toDisplayString(comment.dealerResponse.date), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.dealerName), 1 /* TEXT */),
                                _createElementVNode("p", _hoisted_22, _toDisplayString(comment.dealerResponse.text), 1 /* TEXT */)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]));
                }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_23, [
                (_ctx.hasNavigationButtons)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "page-buttons__previous",
                        disabled: _ctx.previousButtonDisabled,
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.changePage($event, 'previous')))
                    }, _toDisplayString("< Previous"), 8 /* PROPS */, _hoisted_24))
                    : _createCommentVNode("v-if", true),
                (_ctx.hasNavigationButtons)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "page-buttons__next",
                        disabled: _ctx.nextButtonDisabled,
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.changePage($event, 'next')))
                    }, _toDisplayString("Next >"), 8 /* PROPS */, _hoisted_25))
                    : _createCommentVNode("v-if", true)
            ])
        ])
    ]));
}
